import React from 'react';
import BlogListGeneric from '../../Generic/BlogListGeneric';

const BlogListNews = () => {
    return (
      <BlogListGeneric postType="News" heading="News Posts" />
  );
};

export default BlogListNews;